<template>
  <div>
    <report-pbi
      report-id="9ad72920-33cf-4e0b-ac59-f734fdd5ac76"
      group-id="5de7d4a7-b0d1-41a8-a978-693e831cfdcd"
    ></report-pbi>
  </div>
</template>

<script>
import reportPbi from '@/components/organisms/report-pbi/index.vue';

export default {
  components: {
    reportPbi,
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  background-color: #fff;
  width: 100px;
  height: 50px;
}
</style>
